import RadioButton from './RadioButton';

export { Props } from './RadioButton';
export default RadioButton;
